<script lang="ts">
    export let code:string;

    import Button from "./button.svelte";

    let viewLarge = false;
    let viewButtonLabel = 'Show more'
    function toggleVisibleAreaSize() {
        viewLarge = !viewLarge;
        console.log('togglin');
        if (viewLarge) {
            viewButtonLabel = 'Show less';
        } else {
            viewButtonLabel = 'Show more'
        }
    }

    function exportDataToClipBoard() {
		navigator.clipboard.writeText(code);
	}
</script>

<code class:tall="{viewLarge}">
    {code}
</code>
<div class="button-area">
    <Button label={viewButtonLabel} handleClick={() => toggleVisibleAreaSize()} role="tertiary" />
    <Button label="Copy" icon="copy" handleClick={() => exportDataToClipBoard()} role="primary" />        
</div>


<style>
	code {
		max-height: 128px;
		white-space: pre;
		overflow: scroll;
		display: block;
		max-width: 100%;
		background-color: var(--background-secondary);
		padding: 1rem;
		border-radius: 8px;
        margin: 1rem 0;
        border: 1px solid var(--background-offset);
	}
    .tall {
        max-height: 80vh; 
    }
    .button-area {
        display: flex;
        justify-content: right;
    }
    @media (max-width: 960px) {
        code {
			max-height: 20vh;
		}
    }
</style>